import { Injectable, Inject, Injector, DOCUMENT } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';


import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { setStorage, getStorage, createUUID, encryptData } from '../utilities';
import { environment } from '../../../environments/environment';
import { BaseComponents } from '../../base.component';

// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CookieService } from 'ngx-cookie-service';

import { ConsentMode } from 'src/app/models/gtag.model';

declare var gtag: Function;
@Injectable({
  providedIn: 'root'
})
export class GoogleTagService extends BaseComponents{
  private persistanceCookie: string = 'google-analytic-permission';
  private isAllowGoogleAnalytic: boolean = false;
  private isInsertHeader: boolean  = false;

  $statePermissionTag: BehaviorSubject<string> = new BehaviorSubject(null);
  permission: Observable<boolean> = this.$statePermissionTag.pipe(
    switchMap(isallow => of(this.cookieService.get(this.persistanceCookie) ? true: false)),
    tap(isallow => {
          if(isallow){
            // this.setTageGoogleAnalytic()
            this.isAllowGoogleAnalytic = true;
          }
        })
  )

  constructor(
    @Inject(DOCUMENT) private doc, 
    protected injectorObj: Injector,
    private cookieService: CookieService, 
    private router: Router,
    //private logger: NGXLogger,
    private titleService: Title,
    // private gtmService: GoogleTagManagerService
  ) {
    super(injectorObj);
  }

  setCookieGoogleAnalytic(): void {
    const uuid: string = createUUID();
    // console.log(uuid)
    this.setCookie(this.persistanceCookie,`allow-keeping_${uuid}`, 365 )

  }

  setCookie(name: string, value: string, days: number): void {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    this.doc.cookie = name + "=" + (value || "") + expires + "; path=/";
    // console.log(this.doc.cookie.expires)
    // document.cookie = name + "=" + (value || "") + expires + "; path=/";
    // let d = new Date()
    // this.doc.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
  }

  getCookie(name: string) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setTageGoogleAnalytic() {
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
          data: 'ggwp'
        };
        // this.gtmService.pushTag(gtmTag);
      }
    });

    // if(this.isInsertHeader) return ;
    // console.log("insert gtm")
    // const gooleTage = this.doc.createElement('script');
    // gooleTage.src = `https://www.googletagmanager.com/gtag/js?id=${environment.google_tage_analytic_config}`;
    // const windowFrame = this.doc.createElement('script');
    // windowFrame.text = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${environment.google_tage_analytic_config}');`
    // this.doc.head.insertBefore(windowFrame, this.doc.head.firstChild);
    // this.doc.head.insertBefore(gooleTage, this.doc.head.firstChild);
    // this.isInsertHeader = true;
    
  }

  // private listenForRouteChanges() {
  //   this.router.events.subscribe(event => {    
  //     if (event instanceof NavigationEnd && this.isAllowGoogleAnalytic) {
  //       // console.log(event.urlAfterRedirects);
  //       gtag('config', environment.google_tage_analytic_config, {
  //         'page_path': event.urlAfterRedirects,
  //       });
  //       // console.log('Sending Google Analytics hit for route', event.urlAfterRedirects);
  //       // console.log('Property ID', environment.google_tage_analytic_config);
  //       this.logger.debug('Sending Google Analytics hit for route', event.urlAfterRedirects);
  //       this.logger.debug('Property ID', environment.google_tage_analytic_config)
  //     }
  //   });
  // }

  public setEventTage(title: string){
    this.titleService.setTitle(title);
    // const url:string = this.router.url;
    // console.log('url path: ', url);
    // this.logger.debug('url path: ', url);
    // this.logger.debug('title path: ', title);

    // if(!this.isAllowGoogleAnalytic) return ;
    // gtag('config', environment.google_tage_analytic_config, {
    //     'page_path': url,
    // });
  }

  public event(eventName: string, params: {}) {
    // gtag('event', eventName, params);
  }

  public setCookieConsentMode(action: string, params: ConsentMode) {
    // gtag('consent', action, params);
  }

  public setGAConfiguration() {
    // gtag('config', environment.gtag_tag_id, { 
    //   'anonymize_ip': false
    // });
  }
  
}
